module.exports = __webpack_public_path__ + "static/media/oppo-indonesia-4.d6e2ddec.jpg";